import request from '@/utils/request';
export const defaultStateData = {
  id: 0,
  enabled: true,
  code: undefined,
  gstCode: undefined,
  countryId: undefined,
  name: '',
  country: {
    id: undefined
  }
};
export const getStates = params => request({
  url: '/states',
  method: 'get',
  params
});
export const getStateById = id => request({
  url: `/states/${id}`,
  method: 'get'
});
export const updateState = (id, data) => request({
  url: `/states/${id}`,
  method: 'patch',
  data
});
export const deleteState = id => request({
  url: `/states/${id}`,
  method: 'delete'
});
export const createState = data => request({
  url: '/states/',
  method: 'post',
  data
});